import Api from "next_report/api.js"

export default {
  updateFilter({ commit, dispatch }, filter) {
    commit("updateFilter", filter)
    dispatch("updateCounts")
  },
  updateCounts({ commit },) {
    Api.fetch("total_count:all", {}).then((r) => {
      commit("updateCounts", r.data)
    })
  }
}
